import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { FlatpickrDefaults } from 'angularx-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { German } from 'flatpickr/dist/l10n/de';
import { Italian } from 'flatpickr/dist/l10n/it';
import { Russian } from 'flatpickr/dist/l10n/ru';
import { english } from 'flatpickr/dist/l10n/default';

const FLATPICKR_LOCALES: { [lang: string]: object } = {
  es: Spanish,
  de: German,
  it: Italian,
  ru: Russian,
  en: english
};

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['en', 'es', 'de', 'it', 'ru'];

  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
    private flatpickrDefaults: FlatpickrDefaults
  ) {
    this.translate.addLangs(this.languages);

    let browserLang: any;
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    } else {
      browserLang = translate.getBrowserLang();
    }

    const lang = browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en';
    translate.use(lang);
    this._applyFlatpickrLocale(lang);
  }

  public setLanguage(lang: any) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
    this._applyFlatpickrLocale(lang);
  }

  private _applyFlatpickrLocale(lang: string): void {
    this.flatpickrDefaults.locale = FLATPICKR_LOCALES[lang] ?? Spanish;
  }

}
